var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { DespachoPage } from '../../model/despacho-diario';
import { DespachoService } from '../../services/despacho.service';
import { CommonService } from '../../services/common.service';
import { KeycloakService } from '../../services/keycloak.service';
import { Observable } from 'rxjs/Rx';
var DespachoDiarioFilterComponent = DespachoDiarioFilterComponent_1 = (function () {
    function DespachoDiarioFilterComponent(router, _http, _desService, _comService) {
        this.router = router;
        this._http = _http;
        this._desService = _desService;
        this._comService = _comService;
        this.search = new EventEmitter(true);
        this.activateList = false;
        this.activatePage = false;
        this.curPage = 0;
        this.visible = false;
        this.searchFilter = { fecha_desde: "", fecha_hasta: "", org_id: 0, sec_id: 0, habil: false, favorito: false, caratula: "", tipoDoc: "", documento: "",
            usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10 };
        this.valuedate = new Date(Date.now());
        this.valuedateHasta = new Date(Date.now());
        this.currentDate = new Date();
        this.habilitacion = false;
        this.favorito = false;
        this.cantResul = 10;
        DespachoDiarioFilterComponent_1._observable = new Observable(function (observer) {
            return DespachoDiarioFilterComponent_1._observer = observer;
        }).share();
    }
    DespachoDiarioFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var date = new Date();
        this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        this.searchFilter.fecha_hasta = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        this._comService.findLocalidades().subscribe(function (response) {
            _this.cirList = response;
            _this.searchFilter.cir_id = _this.cirList[0].id;
            var that = _this;
            _this._comService.findOrgByCir(_this.cirList[0].id).subscribe(function (response) {
                that.orgList = response;
            });
        });
        this._comService.findTiposDocumentos().subscribe(function (response) {
            _this.tdocList = response;
        });
    };
    DespachoDiarioFilterComponent.prototype.onChangeSelectCir = function (selected) {
        var _this = this;
        this.searchFilter.cir_id = selected;
        this.searchFilter.org_id = 0;
        this.searchFilter.sec_id = 0;
        if (this.searchFilter.cir_id != 0) {
            this._comService.findOrgByCir(this.searchFilter.cir_id).subscribe(function (response) {
                _this.orgList = response;
            });
        }
        else {
            this.orgList = [];
            this.secList = [];
        }
    };
    DespachoDiarioFilterComponent.prototype.onChangeSelectOrg = function (newValue) {
        var _this = this;
        this.searchFilter.org_id = newValue;
        this.searchFilter.sec_id = 0;
        if (this.searchFilter.org_id != 0) {
            this._comService.findSecByOrg(this.searchFilter.org_id).subscribe(function (response) {
                _this.secList = response;
            });
        }
        else {
            this.secList = [];
        }
    };
    DespachoDiarioFilterComponent.prototype.onClickHabil = function (ev) {
        this.searchFilter.habil = !this.searchFilter.habil;
    };
    DespachoDiarioFilterComponent.prototype.onClickFav = function (ev) {
        //console.log("click fav" + ev);
        this.searchFilter.favorito = !this.searchFilter.favorito;
    };
    DespachoDiarioFilterComponent.prototype.onChangeSelectSec = function (selected) {
        this.searchFilter.sec_id = selected;
    };
    DespachoDiarioFilterComponent.prototype.onClickSearch = function () {
        //console.log("search despachooooo ");
        this.hideErrorMsg();
        var parts = this.searchFilter.fecha_desde.split('/');
        var partsh = this.searchFilter.fecha_hasta.split('/');
        var desdeDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
        var hastaDate = new Date(Number(partsh[2]), Number(partsh[1]) - 1, Number(partsh[0]));
        var diff = Math.abs(hastaDate.getTime() - desdeDate.getTime());
        var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        var permitidos = "";
        try {
            permitidos = this._comService.getConfiguracion("DDI_DIAS");
        }
        catch (error) {
            //console.log("catch permitidos ");
        }
        //console.log("permitidos " + permitidos);
        if (permitidos != "" && diffDays > Number(permitidos)) {
            this.showErrorMessage("La cantidad de dias a buscar debe ser menor");
        }
        else {
            if (typeof (this.searchFilter.cir_id) === "undefined") {
                this.searchFilter.cir_id = this.cirList[0].id;
            }
            //console.log("-> qqqqq = " + JSON.stringify(this.searchFilter));
            if (this.selectedCir != 0 && this.searchFilter.fecha_desde != "" && this.searchFilter.fecha_hasta != null) {
                //console.log("search despacho");
                this._comService.emitBlocking(true);
                //this.router.navigate(['/despacho']);
                this.router.navigate(['/despacho'], { queryParams: { p: btoa(JSON.stringify(this.searchFilter)) } });
                if (DespachoDiarioFilterComponent_1._observer) {
                    DespachoDiarioFilterComponent_1._observer.next(this.searchFilter);
                }
            }
            else {
                this.showErrorMessage("Los filtros Fecha Desde/Hasta son obligatorios");
            }
        }
    };
    DespachoDiarioFilterComponent.prototype.onChangeDate = function (select) {
        this.searchFilter.fecha_hasta = this.searchFilter.fecha_desde;
    };
    DespachoDiarioFilterComponent.prototype.onClickCancel = function () {
        this.ngOnInit();
        this.searchFilter.org_id = 0;
        this.searchFilter.sec_id = 0;
        this.searchFilter.favorito = false;
        this.searchFilter.habil = false;
        var elementHab = document.getElementById("checkHabil");
        elementHab.checked = false;
        var elementFav = document.getElementById("checkFav");
        elementFav.checked = false;
        this.searchFilter.numero = null;
        this.searchFilter.anio = null;
        this.searchFilter.caratula = "";
        this.searchFilter.tipoDoc = "";
        this.searchFilter.documento = "";
        this.despachoList = new DespachoPage(0, 0, 0, []);
        this.orgList = [];
        this.secList = [];
        this.hideErrorMsg();
        this.activateList = false;
        this.cantResul = 10;
        this.curPage = 0;
    };
    DespachoDiarioFilterComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    DespachoDiarioFilterComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    DespachoDiarioFilterComponent.observable = function () {
        return DespachoDiarioFilterComponent_1._observable;
    };
    DespachoDiarioFilterComponent.prototype.onChangeSelectTipo = function (selected) {
        this.searchFilter.tipoDoc = selected;
    };
    return DespachoDiarioFilterComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DespachoDiarioFilterComponent.prototype, "search", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], DespachoDiarioFilterComponent.prototype, "visible", void 0);
DespachoDiarioFilterComponent = DespachoDiarioFilterComponent_1 = __decorate([
    Component({
        //selector: 'despacho-diario-component',
        moduleId: module.id,
        selector: 'despacho-diario-filter',
        templateUrl: 'despacho-diario-filter.component.html'
    }),
    __metadata("design:paramtypes", [Router,
        Http,
        DespachoService,
        CommonService])
], DespachoDiarioFilterComponent);
export { DespachoDiarioFilterComponent };
var DespachoDiarioFilterComponent_1;
//# sourceMappingURL=despacho-diario-filter.component.js.map